import React, { useState, useEffect, useMemo, useRef } from "react";
import { Box, Grid } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HeavyTable from "../components/table/HeavyTable";
import {
  makeSureIsArray,
  loadData,
  controlView,
  controlFilter,
} from "../functions/general";
import { useDispatch } from "react-redux";
import { resetCompetition } from "../actions";
import { getTeamCompetitions } from "../functions/getData";
import { isAdmin, isPartnerOrAssistant } from "../functions/checkrole";
import NunitoText from "../components/general/NunitoText";
import ReusableTextField from "../components/general/ReusableTextField";
import ReusableButton from "../components/general/ReusableButton";
import ViewAndFilterButton from "../components/ViewAndFilterButton";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import NoData from "../components/general/NoData";
import Loader from "../components/general/Loader";
const competitionHeader = () =>
  [
    { id: "name", label: "Team Competition" },
    { id: "status", label: "Status" },
    { id: "global_registration_date", label: "Global Registration Date" },
    {
      id: "competition_start_date",
      label: isPartnerOrAssistant()
        ? "Country Competition Start"
        : "Competition Start",
    },
    {
      id: "competition_end_date",
      label: isPartnerOrAssistant()
        ? "Country Competition End"
        : "Competition End",
    },
    isAdmin() && { id: "competition_organization", label: "Organization" },
    { id: "format", label: "Format" },
  ].filter(Boolean);
const initialParams = "?limits=10";
export default function TeamCompetitions() {
  document.title = "Team Competition";
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  const [header, setHeader] = useState(competitionHeader());
  const [competitionTable, setCompetitionTable] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [firstLoaded, setFirstLoaded] = useState(false);
  const [viewing, setViewing] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const [id, setId] = useState("");
  const [selected, setSelected] = useState([]);
  const [selecting, setSelecting] = useState([]);
  const [onDelete, setOnDelete] = useState(false);
  const [onAddPartner, setOnAddPartner] = useState(false);
  const [onUpload, setOnUpload] = useState(false);
  const handleView = () => controlView(viewing, setViewing, setFiltering);
  const handleFilter = () => controlFilter(filtering, setFiltering, setViewing);

  const getData = (params, signal) => {
    setSelected([]);
    setSelecting([]);
    loadData(
      setLoadingTable,
      setFirstLoaded,
      getTeamCompetitions,
      params,
      setCompetitionTable,
      setFilterOptions,
      { title: "team_competition" },
      signal
    );
  };

  const controller = useMemo(() => new AbortController(), []);
  const signal = controller.signal;
  useEffect(() => {
    isMounted.current = true;
    getData(initialParams, signal);
    return () => {
      controller.abort();
      isMounted.current = false;
    };
  }, [controller, signal]);

  console.log(competitionTable);

  return (
    <Box className="wrapperBox">
      <LoadingBackdrop loading={loading} />
      <Grid
        className="firstRowContainer"
        container
        justifyContent="space-between"
      >
        <div className="dashboardAndSelfBtnDiv">
          <ReusableButton
            text="Dashboard"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            width={125}
            br={18}
            to="/dashboard"
            iconType="home"
          />
          <ChevronRightIcon />
          <ReusableButton
            text="Team Competitions"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            br={18}
            onClick={() => dispatch(resetCompetition())}
          />
        </div>
        <div className="viewAndFilterBtnDiv">
          <ViewAndFilterButton
            text="View Options"
            state={viewing}
            fontSize={14}
            height={42}
            onClick={handleView}
            marginRight={10}
          />
          <ViewAndFilterButton
            text="Filter"
            state={filtering}
            fontSize={14}
            height={42}
            onClick={handleFilter}
          />
        </div>
      </Grid>
      <Grid className="tableContainer" container>
        <NunitoText
          value="Team Competitions"
          fontSize={40}
          fontWeight={700}
          italic
          color="#144A94"
        />
        <Grid
          className="searchAndBtnContainer"
          container
          alignItems="center"
          justifyContent="space-between"
        >
          <ReusableTextField
            type="search"
            width={500}
            height={60}
            bgColor="#F2F2F2"
            placeholder="Search using keyword"
            state={search}
            // setState={onChangeSearch}
            onBlur
          />
        </Grid>
        <NunitoText
          value='Search only in "Team Competition" column'
          fontSize={20}
          fontWeight={400}
          italic
          color="#144A94"
        />
        {loadingTable && <Loader height={600} />}
        {!loadingTable && competitionTable && (
          <HeavyTable
            headers={header}
            list={{ data: makeSureIsArray(competitionTable) }}
            title="team_competition"
            rowsPerPage={rowsPerPage}
            setOnDelete={setOnDelete}
            fixed={["name"]}
            selecting={selecting}
            setSelecting={setSelecting}
            selected={selected}
            setSelected={setSelected}
            setId={setId}
            setOnAddUser={setOnAddPartner}
            setOnUpload={setOnUpload}
          />
        )}
        {!loadingTable &&
          firstLoaded &&
          competitionTable &&
          !makeSureIsArray(competitionTable).length && <NoData height={600} />}
      </Grid>
    </Box>
  );
}
